import { Card, CardHeader, Icon, ProgressBar } from '@/components/ui';
import { cn } from '@/utils/cn';

/**
 * How far along the employer page is, with the next thing worth doing first.
 *
 * The API sends the sections in the order it recommends; the unfinished ones
 * keep that order and move above the finished ones, so the top line is always
 * the next step.
 */
export function BrandingCompletion({ completion }) {
  const sections = completion?.sections ?? [];
  const todo = sections.filter((section) => !section.complete);
  const done = sections.filter((section) => section.complete);

  return (
    <Card>
      <CardHeader
        title="Page completion"
        description={
          todo.length === 0 ? 'Every section is filled in.' : `Next: ${todo[0].hint.toLowerCase()}.`
        }
      />
      <ProgressBar value={completion?.percentage ?? 0} label="Complete" />
      <ul className="mt-4 space-y-2" aria-label="Sections">
        {[...todo, ...done].map((section, index) => (
          <li key={section.key} className="flex items-start gap-2.5 text-sm">
            {section.complete ? (
              <span
                aria-hidden="true"
                className="bg-success-50 text-success-700 mt-px grid size-5 shrink-0 place-items-center rounded-full"
              >
                <Icon name="check" size={12} />
              </span>
            ) : (
              <span
                aria-hidden="true"
                className={cn(
                  'mt-px size-5 shrink-0 rounded-full border-2',
                  index === 0 ? 'border-brand-500' : 'border-line',
                )}
              />
            )}
            <span className={section.complete ? 'text-ink-muted' : 'text-ink'}>
              {section.label}
              {section.complete ? (
                <span className="sr-only"> (done)</span>
              ) : (
                <span className="text-ink-muted block text-xs">{section.hint}</span>
              )}
            </span>
          </li>
        ))}
      </ul>
    </Card>
  );
}
